<template>
<div class="auth-wrapper auth-v1 px-2">

    <div class="auth-inner py-2">
        <b-overlay :show="loading" spinner-variant="primary" spinner-type="grow" spinner-large rounded="sm">

            <!-- Register v1 -->
            <b-card class="mb-0">
                <b-img thumbnail :src='logo' fluid class="mb-2" @click="get_member_detail()" />

                <b-card-title class="mb-1">
                    查詢 / 增值戶口餘額
                </b-card-title>
                <b-card-text class="mb-2">
                </b-card-text>

                <!-- form -->
                <validation-observer ref="registerForm">
                    <h4 class="brand-text text-primary ml-1" v-if="valid === false">Invalid Link</h4>
                    <b-form v-if="insert === false && valid === true">
                        <b-form-group label="商戶 Client Name" label-for="client">
                            <b-form-input id="client_name" v-model="member.client_name" trim readonly />

                        </b-form-group>

                        <b-form-group label="餘額" label-for="Price">
                            <b-input-group prepend="$">
                                <b-form-input id="price" style="font-weight: bold;" v-model="debit" trim readonly />
                            </b-input-group>
                        </b-form-group>
                        <b-form-group label="按金 Deposit" label-for="按金 Deposit" v-if="deposit > 0">
                            <b-input-group prepend="$">
                                <b-form-input id="deposit" style="font-weight: bold;" v-model="deposit" trim readonly />
                            </b-input-group>
                        </b-form-group>
                        <b-form-group label="增值金額" label-for="增值金額" >
                        <b-form-spinbutton
      id="sb-step"
      v-model="topup"
      :step="step"
      :min="minimum_amount"
      size="lg"      
      max="1000"
    />
    </b-form-group>
                        <hr />
                       
                        <div id="stripe" v-if="member.payment_gateway == 'STRIPE'">
                            <b-form-group label="Credit Card Number" label-for="card">
                                <b-form-input id="card" v-mask="'#### #### #### ####'" v-model="card.number" trim />
                            </b-form-group>
                            <b-form-group label="Expiry Date (YYYY-MM)" label-for="Expiry Date">
                                <b-form-input id="expire" v-mask="'####-##'" v-model="card.expire" trim />
                            </b-form-group>
                            <b-form-group label="CVC" label-for="cvc">
                                <b-form-input id="cvc" v-mask="'###'" v-model="card.cvc" trim />
                            </b-form-group>
                            <b-form-group label="總額 Total Amount" label-for="總額 Total Amount">
                                <b-input-group prepend="$">
                                    <b-form-input id="price" style="font-weight: bold;" :value="topup" trim readonly />
                                </b-input-group>
                            </b-form-group>
                            <b-button variant="primary" block type="button" @click="submit_member">
                                確定 Submit
                            </b-button>
                            <b-row class="mt-2">
                                <b-col>
                                    <b-img style="width:100%" :src="require('@/assets/images/svg/mastercard.svg')" />
                                </b-col>
                                <b-col>
                                    <b-img style="width:100%" :src="require('@/assets/images/svg/unionpay.svg')" />
                                </b-col>
                                <b-col>
                                    <b-img style="width:100%" :src="require('@/assets/images/svg/visa.svg')" />
                                </b-col>
                                <b-col>
                                    <b-img style="width:100%" :src="require('@/assets/images/svg/ae.png')" />
                                </b-col>
                            </b-row>
                        </div>
                       
                    </b-form>

                </validation-observer>
                <hr />
                <div class="text-center" style="font-size:10px;color:#888;">Power by CloudFit Pro</div>
            </b-card>
            <!-- /Register v1 -->
        </b-overlay>
    </div>
</div>
</template>

  
  
<script>
import {
    ValidationProvider,
    ValidationObserver
} from 'vee-validate'
import {
    BCard,
    BLink,
    BCardTitle,
    BCardText,
    BForm,
    BImg,
    BRow,
    BCol,
    BFormTextarea,
    BButton,
    BFormInput,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    BFormCheckbox,
    BOverlay,
    BFormSpinbutton
} from 'bootstrap-vue'
import router from '@/router'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import Cleave from 'vue-cleave-component'

import {
    required,
    email
} from '@validations'
import {
    togglePasswordVisibility
} from '@core/mixins/ui/forms'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
    components: {
        VuexyLogo,
        BImg,
        BRow,
        Cleave,
        BCol,
        BFormSpinbutton,
        // BSV
        BCard,
        BLink,
        BCardTitle,
        router,
        BCardText,
        BForm,
        BButton,
        BOverlay,
        BFormInput,
        BFormGroup,
        BFormTextarea,
        BInputGroup,
        BInputGroupAppend,
        BFormCheckbox,
        // validations
        ValidationProvider,
        ValidationObserver,
    },
    mixins: [togglePasswordVisibility],

    watch: {
        "card.number": {
            handler(newValue, oldValue) {
                console.log(newValue.substring(0, 1))
                switch (newValue.substring(0, 1)) {
                    case "3":
                        this.credit_card_format = '#### ###### #####'
                        this.cvc_format = '####'
                        break;
                    default:
                        this.credit_card_format = '#### #### #### ####'
                        this.cvc_format = '###'
                }
            }
        }
    },
    data() {
        return {
            number: {
            numeral: true,
            numeralThousandsGroupStyle: 'thousand',
            },
            regEmail: '',
            username: '',
            member: null,
            loading: false,
            valid: true,
            topup:null,
            password: '',
            status: '',
            minimum_amount:100,
            insert: false,
            mlabel: '價錢 Price',
            deposit: 0,
            client: {
                name: null,
                mobile: null,
                signature: null,
                verify_code: null,
            },
            plan: {
                code: null,
                time_limit: null,
                price: null,
                status: null,
                period_quantity: null,
                period_unit: null,
                uuid: null
            },
            card: {
                number: null,
                expire: null,
                cvc: null,
            },
            // validation rules
            required,
            email,
            step:100,
            logo: null,
            member: {
                client_name: null
            },
            member_login: false,
        }
    },
    computed: {
        total_amount() {
            return parseInt(this.plan.amount) + parseInt(this.deposit)
        },
        passwordToggleIcon() {
            return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
        },
    },
    created() {
        this.get_member_detail()
        if (this.$route.query.member !== null) {
            this.member_login = true
            this.member = this.$route.query.member
        }
    },
    methods: {
        bbmsl_submit() {
            this.loading = true
            const {
                isEmpty,
                data
            } = this.$refs.signaturePad.saveSignature()
            this.client.signature = data
            this.$http.post(process.env.VUE_APP_API_BASE + `/paylink/pay/${this.member}/`, {
                    card: this.card,
                    client: this.client,
                    amount: this.topup,
                    method: "paylink",
                    type: "debit"
                })
                .then(res => {
                    if (res.data.result === true) {
                        if (res.data.exist_card === true) {
                            this.$router.push(res.data.url)
                        } else {
                            window.location.href = res.data.bbmsl_url;
                        }
                    } else {
                        this.loading = false
                        this.$toast({
                            component: ToastificationContent,
                            position: 'top-center',
                            props: {
                                title: 'Error',
                                icon: 'XIcon',
                                variant: 'danger',
                                text: res.data.message,
                            },
                        })
                    }
                })
        },
        get_member_detail() {
            this.$http.get(process.env.VUE_APP_API_BASE + `/paylink/member/` + router.currentRoute.params.member_uuid + '/')
                .then(res => {
                    if (res.data.result === false) {
                        this.valid = false
                    } else {
                        this.member = res.data.member
                        this.logo = res.data.member.logo
                        this.debit = res.data.debit
                        this.step = res.data.step
                        this.minimum_amount = this.topup = res.data.minimum_amount
                       
                        this.valid = true
                    }
                })
        },
        
        submit_member() {
            this.loading = true
            this.$http.post(process.env.VUE_APP_API_BASE + `/paylink/pay/${router.currentRoute.params.member_uuid}/`, {
                    card: this.card,
                    amount: this.topup,
                    method: "paylink",
                    type: "debit"
                })
                .then(res => {
                    if (res.data.result === true) {
                        this.valid = false
                        this.loading = false
                        this.$swal({
                            title: '已成功增值',
                            html: '我們亦會用WhatsApp傳送收據給你.<br><br>',
                            icon: 'success',
                            showConfirmButton: false,
                            buttonsStyling: false,
                            backdrop: true,
                        })
                    } else {
                        this.loading = false
                        this.$toast({
                            component: ToastificationContent,
                            position: 'top-center',
                            props: {
                                title: 'Error',
                                icon: 'XIcon',
                                variant: 'danger',
                                text: res.data.message,
                            },
                        })
                    }
                })
        },
    }
}
</script>
  
  
<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
